import { observer } from "mobx-react";
import * as React from "react";
import { Area } from "../General/Area";
import { FullScreen } from "../General/FullScreen";
import { Toolbar } from "../General/Toolbar";
import { ReaderToolbarMode, ReaderToolbarPart } from "../Reader/ReaderToolbarPart";
import { VideoComponent } from "./Video";

interface IVideoViewProps {
	id: string;
	docId: string;
	docLanguage: string;
	collectionId: string;
	downloadName: string;
	canDownload: boolean;
	fileName: string;
	originalFilename: string;
	isDeleted: boolean;
}

@observer
export class VideoView extends React.Component<IVideoViewProps, {}> {

	render() {
		let id = this.props.id;
		let path = encodeURI(`/files/${id}.mp4`);
		return <Area>
			<FullScreen>
				<Toolbar>
					<ReaderToolbarPart
						id={this.props.id}
						docId={this.props.docId}
						docLanguage={this.props.docLanguage}
						collectionId={this.props.collectionId}
						downloadName={this.props.downloadName}
						canDownload={this.props.canDownload}
						mode={ReaderToolbarMode.Video}
						fileName={this.props.fileName}
						extension=".mp4"
						isDeleted={this.props.isDeleted}
						originalFilename={this.props.originalFilename}
					/>
				</Toolbar>
				<VideoComponent params={{ videoSrc: path, videoType: "video/mp4" }} />
			</FullScreen>
		</Area>;
	}

}